var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAggiungiTabella(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "aggiungi-tabella") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aggiungi-tabella"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2-Copy",
    fill: "#009846",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9180611,8.04558458 C15.5265834,7.65410687 14.8926033,7.65410687 14.5011255,8.04558458 L11.9819063,10.5648038 L9.46268714,8.04558458 C9.07120943,7.65410687 8.43722931,7.65410687 8.04575159,8.04558458 C7.65427388,8.43706229 7.65427388,9.07171046 8.04575159,9.46252013 L10.5649708,11.9817393 L8.04575159,14.5016266 C7.65427388,14.8924362 7.65427388,15.5270844 8.04575159,15.9185621 C8.24149045,16.114301 8.49735387,16.2118364 8.75388534,16.2118364 C9.01041681,16.2118364 9.26694828,16.114301 9.46268714,15.9185621 L11.9819063,13.3986749 L14.5011255,15.9185621 C14.6968644,16.114301 14.9533959,16.2118364 15.2099273,16.2118364 C15.4664588,16.2118364 15.7223222,16.114301 15.9180611,15.9185621 C16.3095388,15.5270844 16.3095388,14.8924362 15.9180611,14.5016266 L13.3988419,11.9817393 L15.9180611,9.46252013 C16.3095388,9.07171046 16.3095388,8.43706229 15.9180611,8.04558458",
    id: "Path-Copy",
    fill: "#FFFFFF",
    transform: "translate(11.981906, 11.981906) rotate(-315.000000) translate(-11.981906, -11.981906) "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAggiungiTabella);
export default __webpack_public_path__ + "static/media/aggiungi-tabella.e8ab8e072edfa976b18b0810669e3734.svg";
export { ForwardRef as ReactComponent };